import { get, post } from '../../../utils/api';

export default {
  getFeedbackData: city_id => {
    return get({
      url: 'feedback/settings',
      data: { city_id },
    });
  },
  sendFeedbackData: data => {
    return post({
      url: 'feedback/send',
      type: 'form-data',
      data,
    });
  },
};
